'use strict';

const { getWidth } = require('../../deal/frontend/get_dimensions');

class ThumbnailTray {
  constructor(data, $el) {
    this.carouselSize = getWidth($el, { margin: false });
    this.$thumbControlForward = $el.querySelector('.thumbnails-button.forward');
    this.$thumbControlBack = $el.querySelector('.thumbnails-button.back');
    this.$thumbnailWrapper = $el.querySelector('.thumbnail-wrapper');
    this.$thumbnails = this.$thumbnailWrapper.querySelectorAll('li');
    this.$thumbnailTray = this.$thumbnailWrapper.querySelector(
      '#thumbnail-tray'
    );
  }

  onLoad(newImageId) {
    this.updateSelectedThumbnail(newImageId);
    const $thumbnailImgs = this.$thumbnailWrapper.querySelectorAll('li img');

    this.thumbnailDimension = getWidth(this.$thumbnailTray.querySelector('li'));

    const thumbnailSize = $thumbnailImgs.length * this.thumbnailDimension;
    this.$thumbnailTray.style.width = `${thumbnailSize}px`;

    const $thumbnailControls = this.$thumbnailWrapper.querySelector(
      '.thumbnails-controls'
    );
    if (this.carouselSize < thumbnailSize) {
      this.$thumbnailTray.style.margin = '0px';
      $thumbnailControls.style.display = 'block';
      Object.assign(this.$thumbnailWrapper.style, {
        'padding-right': '20px',
        'padding-left': '20px',
      });
      this.calculateThumbnailPages();
    } else {
      $thumbnailControls && $thumbnailControls.parentNode
        ? $thumbnailControls.parentNode.removeChild($thumbnailControls)
        : null;
    }

    this.$thumbControlForward.addEventListener('click', () =>
      this.pageThumbnailsForward()
    );
    this.$thumbControlBack.addEventListener('click', () =>
      this.pageThumbnailsBack()
    );

    window.addEventListener('resize', () => this.calculateThumbnailPages());
  }

  calculateThumbnailPages() {
    const thumbnailSize = parseInt(this.$thumbnailTray.style.width);
    let carouselSize = getWidth(this.$thumbnailWrapper, {
      margin: false,
      padding: false,
    });
    carouselSize -= carouselSize % this.thumbnailDimension;
    this.thumbnailTrayMultiples = carouselSize;
    this.thumbnailTraySize = getWidth(this.$thumbnailTray, {
      border: false,
      margin: false,
    });
    this.thumbnailFullPages = Math.floor(thumbnailSize / carouselSize);
    this.thumbnailHasPartial =
      this.thumbnailFullPages !== thumbnailSize / carouselSize;
  }

  getCurrentThumbnailBounds() {
    const lowerbound = Math.abs(parseInt(this.$thumbnailTray.style.left || 0));
    const higherbound =
      lowerbound +
      getWidth(this.$thumbnailWrapper, { margin: false, padding: false });
    return { lowerbound, higherbound };
  }

  getThumbnailPosition(thumbnail) {
    return {
      left: thumbnail.offsetLeft,
      right: thumbnail.offsetLeft + this.thumbnailDimension,
    };
  }

  updateSelectedThumbnail(newImageId) {
    this.$thumbnails.forEach(el => el.classList.remove('selected'));
    const newThumbnail = this.$thumbnailWrapper.querySelector(
      `li[data-id='${newImageId}']`
    );
    newThumbnail.classList.add('selected');
  }

  adjustThumbnail(newImageId) {
    this.updateSelectedThumbnail(newImageId);

    const $newThumbnail = this.$thumbnailWrapper.querySelector(
      `li[data-id='${newImageId}']`
    );

    if (this.thumbnailHasPartial) {
      const { lowerbound, higherbound } = this.getCurrentThumbnailBounds();
      const position = this.getThumbnailPosition($newThumbnail);

      let newPosition;

      if (position.left < higherbound && position.right > higherbound) {
        newPosition =
          getWidth(this.$thumbnailWrapper, { margin: false, padding: false }) -
          (position.left + this.thumbnailDimension) +
          10;
      } else if (position.left < lowerbound && position.right > lowerbound) {
        newPosition = -position.left;
      }

      if (newPosition !== undefined) {
        this.$thumbnailTray.style.left = `${newPosition}px`;
      }
    }
  }

  jumpToThumbnail(newImageId) {
    this.updateSelectedThumbnail(newImageId);
    const newThumbnail = this.$thumbnailWrapper.querySelector(
      `li[data-id="${newImageId}"]`
    );

    const { lowerbound, higherbound } = this.getCurrentThumbnailBounds();
    const position = this.getThumbnailPosition(newThumbnail);

    if (position.left < lowerbound || position.right > higherbound) {
      const thumbnailEdge =
        getWidth(this.$thumbnailWrapper, { margin: false, padding: false }) -
        getWidth(this.$thumbnailTray, { margin: false }) +
        10;
      const newPosition = Math.max(-position.left, thumbnailEdge);

      this.$thumbnailTray.style.left = `${newPosition}px`;
    }
  }

  pageThumbnailsForward() {
    let position;
    const currentPosition = parseInt(this.$thumbnailTray.style.left || 0);
    const lowerbound = 0;
    const upperbound =
      getWidth(this.$thumbnailWrapper, { margin: false, padding: false }) -
      getWidth(this.$thumbnailTray, { margin: false }) +
      10;
    if (currentPosition === upperbound) {
      position = lowerbound;
    } else {
      position = Math.max(
        upperbound,
        currentPosition - this.thumbnailTrayMultiples
      );
    }
    this.$thumbnailTray.style.left = `${position}px`;
  }

  pageThumbnailsBack() {
    let position;
    const currentPosition = parseInt(this.$thumbnailTray.style.left || 0);
    const lowerbound = 0;
    const upperbound =
      getWidth(this.$thumbnailWrapper, { margin: false, padding: false }) -
      getWidth(this.$thumbnailTray, { margin: false }) +
      10;
    if (currentPosition === lowerbound) {
      position = upperbound;
    } else {
      position = Math.min(
        lowerbound,
        currentPosition + this.thumbnailTrayMultiples
      );
    }
    this.$thumbnailTray.style.left = `${position}px`;
  }
}

module.exports = ThumbnailTray;
